import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItem, ListItemText, Button } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"

export default function Link({ link, createdAt }) {
  return <ListItem
    className="success"
    secondaryAction={<Button color="primary" href={link}>
      Download
    </Button>}
  >
    <ListItemAvatar>
      <Avatar>
        <CloudDownload />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary="Your file is ready" secondary={appendTimestamp("Security Search Results", createdAt)} />
  </ListItem>
}

Link.propTypes = {
  link: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}
